import {TranslationSchema} from "./fr";

export const FEATURES_IT: TranslationSchema = {
}
